import api from './index'
import request from '@/utils/request'
/**
 * @description 码牌取消分配操作
 */
export function cancelDistributeQrcode (data) {
  return request({
    url: `${api.cancelDistributeQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 查看码牌
 */
export function getQrcodePage (data) {
  return request({
    url: `${api.getQrcodePage}`,
    method: 'post',
    data
  })
}
/**
 * @description 码牌分配/绑定列表
 */
export function listDistributeQrcode (data) {
  return request({
    url: `${api.listDistributeQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 码牌分配/绑定操作
 */
export function distributeByAgent (data) {
  return request({
    url: `${api.distributeByAgent}`,
    method: 'post',
    data
  })
}
/**
 * @description 码牌更改
 */
export function changeQrcodeState (data) {
  return request({
    url: `${api.changeQrcodeState}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取码牌类型
 */
export function getQrcodeType (data) {
  return request({
    url: `${api.getQrcodeType}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户已绑定码牌编号列表
 */
export function getBindlistQrcode (data) {
  return request({
    url: `${api.getBindlistQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 语音播报设置
 */
export function setQrcodeAudio (data) {
  return request({
    url: `${api.setQrcodeAudio}`,
    method: 'post',
    data
  })
}
/**
 * @description 码牌信息管理
 */
export function listMerchantQrcode (data) {
  return request({
    url: `${api.listMerchantQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 银标码分账标识管理列表
 */
export function unionRoyaltyList (data) {
  return request({
    url: `${api.unionRoyaltyList}`,
    method: 'post',
    data
  })
}
/**
 * @description 银标码分账标识状态修改
 */
export function unionRoyaltyOnOff (data) {
  return request({
    url: `${api.unionRoyaltyOnOff}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具分配/绑定列表
 */
export function listMachinesDistribute (data) {
  return request({
    url: `${api.listMachinesDistribute}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具类型
 */
export function machinePosType (data) {
  return request({
    url: `${api.machinePosType}`,
    method: 'post',
    data
  })
}
/**
 * @description 校验机具分配
 */
export function checkMachineDistribute (data) {
  return request({
    url: `${api.checkMachineDistribute}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具分配
 */
export function machineDistribute (data) {
  return request({
    url: `${api.machineDistribute}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具取消分配
 */
export function machineCancelDistribute (data) {
  return request({
    url: `${api.machineCancelDistribute}`,
    method: 'post',
    data
  })
}
/**
 * @description 绑定/解绑机具
 */
export function machineBind (data) {
  return request({
    url: `${api.machineBind}`,
    method: 'post',
    data
  })
}
/**
 * @description 根据pinpadid查询操作日志
 */
export function listLogByPinpadid (data) {
  return request({
    url: `${api.listLogByPinpadid}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询机具绑定信息
 */
export function getMachineBindInfo (data) {
  return request({
    url: `${api.getMachineBindInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户机具管理
 */
export function listMerchantMachines (data) {
  return request({
    url: `${api.listMerchantMachines}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具详情
 */
export function reworkSndetail (data) {
  return request({
    url: `${api.reworkSndetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 申请寄回机具
 */
export function applyBackSn (data) {
  return request({
    url: `${api.applyBackSn}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具返修信息
 */
export function reworkSnMsg (data) {
  return request({
    url: `${api.reworkSnMsg}`,
    method: 'post',
    data
  })
}
// 商户 机具模块
/**
 * @description 机具返修信息
 */
export function checkUnionQrcode (data) {
  return request({
    url: `${api.checkUnionQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 码牌管理列表
 */
export function listQrcode (data) {
  return request({
    url: `${api.listQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 申请码牌
 */
export function applyQrcode (data) {
  return request({
    url: `${api.applyQrcode}`,
    method: 'post',
    data
  })
}
/**
 * @description 检查是否商户二维码展示申请按钮
 */
export function checkApplyButton (data) {
  return request({
    url: `${api.checkApplyButton}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取商户银行卡信息
 */
export function getMerchantDetail (data) {
  return request({
    url: `${api.getMerchantDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 机具管理(商户平台)
 */
export function MerchantMachines (data) {
  return request({
    url: `${api.MerchantMachines}`,
    method: 'post',
    data
  })
}

/**
 * @description 新增返修机具
 */
export function addreworkMachine (data) {
  return request({
    url: `${api.addreworkMachine}`,
    method: 'post',
    data
  })
}

/**
 * @description 批量导入返修机具
 */
export function batchAddRework (data) {
  return request({
    url: `${api.batchAddRework}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询如意绑定状况
 */
export function listRuyiMachine (data) {
  return request({
    url: `${api.listRuyiMachine}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询店铺ID
 */
export function queryShopId (data) {
  return request({
    url: `${api.queryShopId}`,
    method: 'post',
    data
  })
}

/**
 * @description 如意机具绑定
 */
export function ruyiMachineBind (data) {
  return request({
    url: `${api.ruyiMachineBind}`,
    method: 'post',
    data
  })
}

/**
 * @description 如意机具解绑
 */
export function ruyiMachineUnbind (data) {
  return request({
    url: `${api.ruyiMachineUnbind}`,
    method: 'post',
    data
  })
}

/**
 * @description 创建店铺
 */
export function addRuyiShop (data) {
  return request({
    url: `${api.addRuyiShop}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询店铺列表
 */
export function listRuyiShop (data) {
  return request({
    url: `${api.listRuyiShop}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取上报信息
 */
export function getReportInfo (data) {
  return request({
    url: `${api.getReportInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 更新店铺状态
 */
export function updateShopStatus (data) {
  return request({
    url: `${api.updateShopStatus}`,
    method: 'post',
    data
  })
}

/**
 * @description 批量解绑
 */
export function batchUnbind (data) {
  return request({
    url: `${api.batchUnbind}`,
    method: 'post',
    data
  })
}

/**
 * @description 查询店铺信息
 */
export function queryShopInfo (data) {
  return request({
    url: `${api.queryShopInfo}`,
    method: 'post',
    data
  })
}

/**
 * @description 查询店铺信息
 */
export function getUnionList (data) {
  return request({
    url: `${api.getUnionList}`,
    method: 'post',
    data
  })
}
